import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/package-library'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  // update(packet, uuid) {
  //   return http.put(`${resource}/${uuid}`, packet)
  // },
  add(packet) {
    return http.post(`${resource}`, packet)
  },
  destroy(packet) {
    // eslint-disable-next-line no-underscore-dangle
    packet._method = 'DELETE'

    return http.post(`${resource}`, packet)
  },
}
